import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isAdminLoggedIn, clearAdminSession } from '@/lib/admin';

export default function AdminGuard() {
  const [ready, setReady] = useState(false);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const loggedIn = isAdminLoggedIn();
    if (!loggedIn) {
      // session 已过期，清除旧 token
      clearAdminSession();
    }
    setAllowed(loggedIn);
    setReady(true);

    // 每分钟检查一次 session 是否过期（24小时自动踢出）
    const timer = setInterval(() => {
      if (!isAdminLoggedIn()) {
        clearAdminSession();
        setAllowed(false);
      }
    }, 60 * 1000);

    return () => clearInterval(timer);
  }, []);

  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brown-50">
        <span className="w-8 h-8 border-2 border-gold-500/30 border-t-gold-500 rounded-full animate-spin"></span>
      </div>
    );
  }

  if (!allowed) {
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
}